import { type JSX, onCleanup, onMount } from "solid-js";

/** The shared quick-look drawer chrome — scrim, dialog, head, body, footer —
 * owning Escape-close so host views never wire their own document listeners. */
export function DrawerShell(props: {
  kicker: string;
  title: string;
  ariaLabel: string;
  closeLabel?: string;
  asideClass?: string;
  onClose: () => void;
  footer: JSX.Element;
  children: JSX.Element;
}) {
  onMount(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    onCleanup(() => window.removeEventListener("keydown", onKeyDown));
  });
  const closeLabel = () => props.closeLabel ?? "Close quick look";
  return (
    <>
      <button
        class="scan-drawer-scrim"
        type="button"
        aria-label={closeLabel()}
        onClick={props.onClose}
      />
      <aside
        class={`scan-quick-drawer${props.asideClass ? ` ${props.asideClass}` : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={props.ariaLabel}
      >
        <div class="scan-drawer-head">
          <div>
            <span class="scan-kicker">{props.kicker}</span>
            <h2>{props.title}</h2>
          </div>
          <button
            class="scan-close"
            type="button"
            aria-label={closeLabel()}
            onClick={props.onClose}
          >
            x
          </button>
        </div>
        <div class="scan-drawer-body">{props.children}</div>
        <div class="scan-drawer-foot">{props.footer}</div>
      </aside>
    </>
  );
}

export function DrawerSection(props: { title: string; children: JSX.Element }) {
  return (
    <section class="scan-drawer-section">
      <h3>{props.title}</h3>
      {props.children}
    </section>
  );
}
